import type { GetUserClubsAndScheduledGamesResponse } from '@ps/web-shared-api-types/v0/SwHomeGames';
import produce from 'immer';

import { PKR_INITIAL_STATE } from '../../constants';
import type { PageData } from '../../types/common';
import { filterTournaments } from '../../utils/filterTournaments';
import { sortClubs } from '../../utils/sortClubs';

export const setUserClubsAndGames = (
  state: PageData | undefined = PKR_INITIAL_STATE,
  { clubInfoList, filteredClubInfoReply }: GetUserClubsAndScheduledGamesResponse
) => {
  const { available, recent } = filterTournaments(filteredClubInfoReply?.tourns);

  return produce(state, (draft) => {
    draft.clubs = sortClubs({ clubs: clubInfoList, prevClubs: state.clubs });
    draft.games.tables = filteredClubInfoReply?.tables;
    draft.games.tourns = available;
    draft.games.recentTourns = recent;
  });
};
